// Bundle sections
const bundleSections = [
  document.getElementById("section1"),
  document.getElementById("section2"),
  document.getElementById("section3"),
];
  
  // State variables
  const sectionData = { 1: null, 2: null, 3: null }; // Tracks product in each section
  let totalItems = 0;
  let totalAmount = 0;
  let productPriceTotal = 0;
  
  // Add product to bundle
  function addToBundle(productId, name, price, image, productPrice, packDiscount, subscriptionDiscount) {
    
    if (totalItems >= 3) {
    console.log("You can only add up to 3 items in the bundle.");
      return;
    }

     console.log("totalItems productId======= ", totalItems, productId);
    
     if (totalItems+1 >= 1) {
        const buttonAdd1 = document.getElementById(`add-${productId}`);
        buttonAdd1.classList.add("hidden");
       
        const buttonAdd2 = document.getElementById(`showCount${productId}`);
        buttonAdd2.classList.remove("hidden");       
       
    }
     if (totalItems < 3) {
        document.getElementById("titleCnt").innerText = totalItems+1; // Update the span
      }
   // document.getElementById(`section${totalItems+1}`).classList.add('active');
    
    const product = {"name":name, "image":image, "price":price, "productPrice": productPrice, "packDiscount": packDiscount, "subscriptionDiscount": subscriptionDiscount};//products.find((p) => p.id === productId);
    
    const emptySectionIndex = bundleSections.findIndex(
      (section, index) => !sectionData[index + 1]
    );
  
    if (emptySectionIndex !== -1) {
      const sectionId = emptySectionIndex + 1;
      sectionData[sectionId] = product; // Track the product in the section
      bundleSections[emptySectionIndex].setAttribute("data-id", productId);
      bundleSections[emptySectionIndex].classList.add("active");
      bundleSections[emptySectionIndex].innerHTML = `
        <img src="${product.image}" alt="${product.name}">
        <p>${product.name}</p><img src="https://cdn.shopify.com/s/files/1/0369/0237/1373/files/remove_p.png?v=1732734474" alt="Remove, ${product.name}" class="cross" onclick="removeFromSection(${sectionId}, ${productId})">`;
      totalItems++;
      totalAmount += product.productPrice; // Add to the total amount

      productPriceTotal += parseFloat(product.productPrice);
      packDiscount = product.packDiscount;
      subscriptionDiscount = product.subscriptionDiscount;
      console.log(productPrice);
      
      updateProductCount(productId, +1, productPriceTotal, packDiscount, subscriptionDiscount);
    }
    if (totalItems >= 3) {
    //alert("You can only add up to 3 items in the bundle.");
     const buttons = document.getElementsByClassName(`plus`);
      Array.from(buttons).forEach(button => {
          button.disabled = true;
          button.classList.add("disabled");
      });

      const actionButtons = document.getElementsByClassName(`action-button`);
      Array.from(actionButtons).forEach(actionButtons => {
          actionButtons.disabled = false;
      });

      //console.log('SHOW')
      jQuery('span.price.main_price, .price_sub .price').show();
      jQuery('.hide_after_fill').hide();
      jQuery('.mobile_only.mobile_only_price').show();
      
    }
    let sectionFull = bundleSections.every(section => section.getAttribute("data-id") !== null);
    //console.log("sectionFull ==== ", sectionFull);    
    
  }
  
  // Remove product directly from section
  function removeFromSection(sectionId, productId) {
    if (!sectionData[sectionId]) return; // If no product in the section, do nothing
  
    const product = sectionData[sectionId];
    sectionData[sectionId] = null; // Clear the product from the section
    bundleSections[sectionId - 1].innerHTML = ""; // Clear the section content
    totalItems--;
    document.getElementById("titleCnt").innerText = totalItems; // Update the span
    document.getElementById(`section${sectionId}`).classList.remove('active');
    
    //console.log("totalItems ======= ", totalItems);
     if (totalItems == 0) {
        const buttonAdd1 = document.getElementById(`add-${productId}`);
        buttonAdd1.classList.remove("hidden");
       
        const buttonAdd2 = document.getElementById(`showCount${productId}`);
        buttonAdd2.classList.add("hidden");

       const buttonAdd = document.getElementById(`add-${productId}`);
       buttonAdd.disabled = false; // Disable the button
        buttonAdd.classList.remove("disabled"); // Add CSS class
       
    }
    if(totalItems < 3){
      
      jQuery('span.price.main_price, .price_sub .price').hide();
      jQuery('.hide_after_fill').show();
      jQuery('.mobile_only.mobile_only_price').hide();
       
      //alert("You can only add up to 3 items in the bundle.");
      const button = document.querySelectorAll(`.plus`)
      const buttons = document.getElementsByClassName(`plus`);
      Array.from(buttons).forEach(button => {
          button.disabled = false;
          button.classList.remove("disabled");
      });
    }

    const actionButtons = document.getElementsByClassName(`product-submit action-button`);
    Array.from(actionButtons).forEach(actionButtons => {
        actionButtons.disabled = true;
    });
    
    totalAmount -= product.productPrice; // Subtract from the total amount

    productPriceTotal -= product.productPrice;
    packDiscount = product.packDiscount;
    subscriptionDiscount = product.subscriptionDiscount;
    
    updateProductCount(productId, -1, productPriceTotal, packDiscount, subscriptionDiscount);
  }
  
  // Remove product globally
 function removeFromBundle(productId) {

  // Find the section that contains the product
  // const sectionIndex = bundleSections.findIndex(
  //   (section, index) => {
  //     const product = sectionData[index + 1];
  //     // Compare based on the `productId`
  //     return product && bundleSections[index].getAttribute("data-id") == productId;
  //   }
  // );

   let sectionIndex = -1;
  for (let i = bundleSections.length - 1; i >= 0; i--) {
    const product = sectionData[i + 1]; // Adjust index for `sectionData`
    if (product && bundleSections[i].getAttribute("data-id") == productId) {
      sectionIndex = i;
      break; // Stop once you find the first match (from the end)
    }
  }
 
  // If found, remove the product from that section
  if (sectionIndex !== -1) {
    const sectionId = sectionIndex + 1; // Convert to 1-based index
    removeFromSection(sectionId, productId);
  }
   const actionButtons = document.getElementsByClassName(`product-submit action-button`);
    Array.from(actionButtons).forEach(actionButtons => {
        actionButtons.disabled = true;
    });
}
  
  // Update product count display
  function updateProductCount(productId, change, productPrice, packDiscount, subscriptionDiscount) {

    const countSpan = document.getElementById(`count-${productId}`);
    const removeButton = document.getElementById(`remove-${productId}`);
     if (!countSpan) {
        console.error(`Element with id count-${productId} not found.`);
        return;
    }
    if (!removeButton) {
        console.error(`Element with id remove-${productId} not found.`);
        return;
    }
    let count = parseInt(countSpan.textContent || "0") + change; // Default to 0 if textContent is empty
    console.log("count ==== ", count);
    if(count == 0){
          const buttonAdd1 = document.getElementById(`add-${productId}`);
        buttonAdd1.classList.remove("hidden");
       
        const buttonAdd2 = document.getElementById(`showCount${productId}`);
        buttonAdd2.classList.add("hidden");

       const buttonAdd = document.getElementById(`add-${productId}`);
       buttonAdd.disabled = false; // Disable the button
        buttonAdd.classList.remove("disabled"); // Add CSS class
      
    }
    countSpan.textContent = count;
    if (count > 0) {
        removeButton.classList.remove("disabled");
    } else {
        removeButton.classList.add("disabled");
    }   

    calculatedDynamicPrice(productPrice, packDiscount, subscriptionDiscount);   
    
    
    if (count >= 3) {
     const buttons = document.getElementsByClassName(`plus`);
      Array.from(buttons).forEach(button => {
          button.disabled = true;
          button.classList.add("disabled");
      });

         const actionButtons = document.getElementsByClassName(`product-submit action-button`);
          Array.from(actionButtons).forEach(actionButtons => {
              actionButtons.disabled = false;
          
          });      
      
    }else{
      const buttons = document.getElementsByClassName(`plus`);
      Array.from(buttons).forEach(button => {
          button.disabled = false;
          button.classList.remove("disabled");
      });      
      
    }
  }

  const actionButtons = document.getElementsByClassName(`product-submit action-button`);
  Array.from(actionButtons).forEach(actionButtons => {
      actionButtons.disabled = true;
  });
  
  // Update total amount
  function updateTotalAmount() {
    const totalAmountElement = document.getElementById("total-amount");
    totalAmountElement.textContent = `0 - ADD TO BAG`;
    document.getElementsByClassName("money")[0].innerText = 0;
  }

   // document.querySelector('#toggleBundleBox').addEventListener('click', function () {
   //    const body = document.querySelector('.options');
   //    body.style.display = body.style.display === 'none' || !body.style.display ? 'block' : 'none';
   //  });


function calculatedDynamicPrice(productPrice, packDiscount, subscriptionDiscount) {
  //if($('[name="purchase_type"]:checked').val() == 'autodeliver'){
    let sDiscountedPrice = (productPrice - ( productPrice * subscriptionDiscount / 100 )).toFixed(2);
    $('.price_sub .sub_discount_price').text('$'+sDiscountedPrice);
    $('.price_sub').find('del').text('$'+productPrice.toFixed(2));
    
    $('span.product-card-price.sub-save').text('$'+sDiscountedPrice);
    $('span.product-card-price.sub-save').find('del').text('$'+productPrice);
    //console.log('subs:', sDiscountedPrice, productPrice);
  //}else{
    let oDiscountedPrice = (productPrice - ( productPrice * packDiscount / 100 )).toFixed(2);
    $('.price.main_price .money').text('$'+oDiscountedPrice);
    //$('.price_sub').find('del').text(productPrice.toFixed(2));
    $('.price.main_price').find('del').text('$'+productPrice.toFixed(2));
    $('span.product-card-price.one-time').html('$'+oDiscountedPrice+'<del>$'+productPrice.toFixed(2)+'</del>');
    //$('span.product-card-price.one-time').find('del').text('$'+productPrice.toFixed(2));
    //console.log('onetime:', oDiscountedPrice, productPrice);
    
  //}  
  
}

$('[name="purchase_type"]').on('change', function(){
  if($('[name="purchase_type"]:checked').val() == 'autodeliver'){    
    $('span.product-card-price.sub-save').html($('.price_sub .sub_discount_price').text()+'<del>'+$('.price_sub del').text()+'</del>');
    //console.log('subs:', sDiscountedPrice, productPrice);
    $('.shiipevery-select.timing_selector').show();
  }else{      
    $('span.product-card-price.one-time').html($('label > span.price.main_price .money').html()+'<del>'+$('.price.main_price del').text()+'</del>');
    //$('span.product-card-price.one-time').html($('span.product-card-price.one-time').text()+'<del>'+$('.price.main_price del').text()+'</del>');
    //console.log('onetime:', oDiscountedPrice, productPrice);
    $('.shiipevery-select.timing_selector').hide();
    
  }    
})
$(document).ready(function(){
  //jQuery('span.price.main_price, .price_sub').hide();
  jQuery('.mobile_only.mobile_only_price').hide();


  $('#toggleBundleBox').click(function() {
    $('.options').slideToggle("fast");
  });
  
});

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});


